import {
  Feature,
  MeasurementRange,
  QualifiedFeature,
  QualifiedFeatureMandatory,
  Qualifier,
  QualifierValue,
} from "../graphql";
import { GenderValue, getSubPopulationFeatureID, Relations } from "shared";

function makeSubPopulationFeature(
  relationId: Relations,
  valueId: string,
  range?: MeasurementRange,
): QualifiedFeature {
  const feature: Partial<Feature> = {
    id: getSubPopulationFeatureID(relationId),
  };
  const qualifier: Partial<Qualifier> = {
    relation: {
      name: "",
      id: relationId,
      type: null,
      multi: false,
    },
    range: range,
    value:
      valueId != null &&
      ({
        id: valueId,
      } as QualifierValue),
  };
  return {
    id: relationId,
    feature,
    qualifiers: [qualifier],
    mandatory: qualifier as QualifiedFeatureMandatory,
  } as QualifiedFeature;
}

export function buildAgeFeature(age: MeasurementRange): QualifiedFeature {
  const qf =
    age && makeSubPopulationFeature(Relations.PERIODS_OF_LIFE, null, age);

  if (qf) {
    qf.feature.name = "Age";
  }
  return qf;
}

export function buildGenderFeature(gender: GenderValue): QualifiedFeature {
  const qf = gender && makeSubPopulationFeature(Relations.GENDER, gender);

  if (qf) {
    qf.feature.name = "Gender";
    const val = qf.qualifiers?.[0].value;
    if (val) {
      val.name =
        val.id === GenderValue.MALE
          ? "Male"
          : val.id === GenderValue.FEMALE
          ? "Female"
          : "Other";
    }
  }
  return qf;
}
